import { render, staticRenderFns } from "./LogoBrandSection.vue?vue&type=template&id=78ab2e0a&scoped=true"
import script from "./LogoBrandSection.vue?vue&type=script&lang=ts"
export * from "./LogoBrandSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoBrandSection.vue?vue&type=style&index=0&id=78ab2e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ab2e0a",
  null
  
)

export default component.exports